import store from '@carvana/purchase-store';
import {
  GetAssignedBucket,
  DashboardModalActions,
  routeTo
} from '@carvana/purchase-helpers';
import * as Services from '../services';
import * as types from './action-types';
import { FetchCustomerRequests } from '../../customer-request/ducks/actions';
import { FetchOPDNotifications } from '../../order-placed/components/notifications/ducks/action';

// eslint-disable-next-line import/no-mutable-exports
export let GetDashboardAndRouteToNextStep = () => {};

export const SetDashboardActions = getDashboardAndRouteToNextStep => {
  GetDashboardAndRouteToNextStep = getDashboardAndRouteToNextStep;
};

export const SetUnsupportedDocumentSelected = errorMessage => {
  return store.dispatch({
    type: types.UNSUPPORTED_DOCUMENT_SELECTED,
    payload: errorMessage
  });
};

const GetExperimentTreatmentBucket = (experimentName, customerId) =>
  GetAssignedBucket({
    environment: process.env.NODE_ENV,
    experimentName: experimentName,
    identifier: customerId
  })
    .then(({ assignedBucket }) => assignedBucket)
    .catch(() => 'control');

export const FetchInsuranceReferral = () =>
  store.dispatch({
    type: types.INSURANCE_REFERRAL_FETCH,
    async payload() {
      return Services.fetchInsuranceReferral();
    }
  });

export const FetchInsuranceReferralUrl = referralId => dispatch =>
  dispatch({
    type: types.INSURANCE_REFERRAL_URL_FETCH,
    async payload() {
      return Services.fetchInsuranceReferralUrl(referralId);
    }
  });

export const UploadDocument = document => dispatch =>
  dispatch({
    type: types.INSURANCE_UPLOAD_DOCUMENT,
    async payload() {
      return Services.uploadDocument(document);
    }
  });

export const SubmitProofOfInsurance = document => {
  DashboardModalActions.ShowModalLoadingSpinner();
  return store
    .dispatch({
      type: types.INSURANCE_UPLOAD_DOCUMENT,
      async payload() {
        return Services.uploadDocument(document);
      }
    })
    .then(() => store.dispatch(FetchCustomerRequests()))
    .then(() => store.dispatch(FetchOPDNotifications()))
    .then(() => store.dispatch(routeTo('/order-placed', 'replace')))
    .catch(() => {
      SetUnsupportedDocumentSelected(
        'An error occurred uploading your proof of insurance document'
      );
      DashboardModalActions.HideModalLoadingSpinner();
    });
};

export const FetchInsuranceConsent = () => dispatch =>
  dispatch({
    type: types.INSURANCE_CUSTOMER_CONSENT_FETCH,
    async payload() {
      return Services.fetchInsuranceConsent();
    }
  });

export const FetchInsuranceProfile = () => dispatch => {
  return dispatch({
    type: types.INSURANCE_PROFILE_FETCH,
    async payload() {
      return Services.fetchInsuranceProfile();
    }
  });
};

export const FetchInsuranceRootQuote = customerId =>
  store
    .dispatch({
      type: types.INSURANCE_QUOTE_FETCH,
      payload: Services.getInsuranceRootQuote()
    })
    .then(({ value }) => {
      const { quoteDetails: { quotes } = {} } = value || {};
      const embeddedQuote = quotes?.find(q => q.name === 'Embedded');

      return GetExperimentTreatmentBucket(
        'insurance-root-quote-suppression',
        customerId
      ).then(assignedBucket => ({ assignedBucket, embeddedQuote }));
    })
    .then(({ assignedBucket, embeddedQuote }) => {
      const suppressionEnabled = assignedBucket === 'control-suppressed';

      if (suppressionEnabled) {
        const priceThreshold = 260;

        const { monthlyPrice } = embeddedQuote || {};
        const thresholdMet = monthlyPrice >= priceThreshold;

        store.dispatch({
          type: types.SUPPRESS_QUOTE,
          payload: { enabled: suppressionEnabled, eligible: thresholdMet }
        });

        return Promise.resolve(suppressionEnabled && thresholdMet);
      }

      return Promise.resolve(false);
    });

export const FetchProgressiveRC1Quote = () =>
  store.dispatch({
    type: types.INSURANCE_PROGRESSIVE_RC1_QUOTE_FETCH,
    payload: Services.getProgressiveRC1Quote()
  });

export const FetchPolicyStatus = () =>
  store.dispatch({
    type: types.INSURANCE_POLICY_FETCH,
    async payload() {
      return Services.getPolicyStatus();
    }
  });

export const ResetUnsupportedDocumentSelected = () => {
  return store.dispatch({
    type: types.RESET_UNSUPPORTED_DOCUMENT_SELECTED
  });
};

export const ShowSampleDocuments = showSampleDocs => {
  return store.dispatch({
    type: types.TOGGLE_SHOW_SAMPLE_DOCUMENTS,
    payload: showSampleDocs
  });
};

export const ValidateProofOfInsurance = file => {
  const formData = new FormData();

  formData.append('file', file);

  return store.dispatch({
    type: types.INSURANCE_VALIDATE_POI,
    payload: Services.validateProofOfInsurance({ formData })
  });
};
